/* eslint-disable react/prop-types,react/require-default-props,no-unused-expressions */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';
import { browserHistory } from 'react-router';

import Icon from '../../Icon';
import Button from '../../Button';
import Controls from '../../ContentArea/Controls';
import ClickableElement from '../../ClickableElement';
import ControlsItem from '../../ContentArea/ControlsItem';
import { actions as uiDrawerActions } from '../../../redux/ui/drawer';
import { actions as uiSidebarActions } from '../../../redux/ui/sidebar';
import { COLORS } from '../../../constants/styles';
import styles from './index.styl';

/*
 * TODO: replace icon transform with initialy rotated icon
 */

const MobileNavbar = ({
  children,
  drawerToggler,
  sidebarToggler,
  location,
  toggleDrawerVisibility,
  toggleSidebarVisibility,
  openContext,
  toggleContext,
  handleChange,
  onClickInfo,
  onClickEdit,
}) => {
  const iconStyle = {
    fill: COLORS.white,
    stroke: COLORS.white,
  };

  const userStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingRight: '10px',
  };

  return (
    <Controls styleName="root" className="pa2">
      <If condition={drawerToggler}>
        <ControlsItem fixed>
          <Button
            icon
            onClick={() =>
              location
                ? browserHistory.push(location)
                : toggleDrawerVisibility()
            }
          >
            <Icon
              name={drawerToggler}
              style={{ ...iconStyle, transform: 'rotate(90deg)' }}
            />
          </Button>
        </ControlsItem>
      </If>
      <If condition={openContext}>
        <ControlsItem fixed>
          <Button
            icon
            onClick={() => {
              toggleContext ? toggleContext() : toggleDrawerVisibility();
              handleChange && handleChange();
            }}
          >
            <Icon
              name={openContext}
              style={{ ...iconStyle, transform: 'rotate(90deg)' }}
            />
          </Button>
        </ControlsItem>
      </If>
      <If condition={children}>
        <ControlsItem>
          <Choose>
            <When condition={sidebarToggler}>
              <ClickableElement
                onClick={() => toggleSidebarVisibility()}
                style={userStyle}
              >
                {children}
              </ClickableElement>
            </When>
            <Otherwise>{children}</Otherwise>
          </Choose>
        </ControlsItem>
      </If>
      <div className="flex">
        {onClickEdit && (
          <Icon
            name="edit"
            style={{ fill: COLORS.white }}
            size={20}
            onClick={onClickEdit}
          />
        )}
        {onClickInfo && (
          <Icon
            name="info"
            style={{ ...iconStyle }}
            size={24}
            onClick={onClickInfo}
            className="ml2"
          />
        )}
      </div>
    </Controls>
  );
};

MobileNavbar.propTypes = {
  children: PropTypes.node,
  drawerToggler: PropTypes.string,
  sidebarToggler: PropTypes.bool,
  toggleDrawerVisibility: PropTypes.func,
  toggleSidebarVisibility: PropTypes.func,
  openContext: PropTypes.string,
  toggleContext: PropTypes.func,
  handleChange: PropTypes.func,
};

const mapDispatchToProps = {
  toggleDrawerVisibility: uiDrawerActions.toggleVisibility,
  toggleSidebarVisibility: uiSidebarActions.toggleVisibility,
};

export default connect(
  null,
  mapDispatchToProps,
)(CSSModules(MobileNavbar, styles, { allowMultiple: true }));



// WEBPACK FOOTER //
// ./src/components/common/MobileNavbar/index.jsx